// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
		//suggestionMode: 'test',
		//suggestionPosition: 'left'
	}
};

(function() {
	BoostPFS.inject(this);

	// Customize style of Suggestion box
	SearchInput.prototype.customizeInstantSearch = function() {
		var suggestionElement = this.$uiMenuElement;
		var searchElement = this.$element;
		var searchBoxId = this.id;
	};
  
    // Start Ticket # 133205
    /*
    InstantSearchResultItemProduct.prototype.compileSuggestionProductPrice = function(){
		// If the multi-currency feature is enabled, update the product price
		this.prepareSuggestionProductPriceData();
		// Check on sale
        var selectedVariant = '';
        for (var i = 0; i < this.data.variants.length; i ++) {
            if (this.data.variants[i].available == true) {
                selectedVariant = this.data.variants[i];
                break;
            }
        }
        if (selectedVariant == '') {
          selectedVariant = this.data.variants[0];
        }
		var onSale = Number(selectedVariant.compare_at_price) > Number(selectedVariant.price);
		// Format price
		var price = Utils.formatMoney(Number(selectedVariant.price));
		var compareAtPrice = '';
		if (this.data && selectedVariant.compare_at_price) {
			compareAtPrice = Utils.formatMoney(Number(selectedVariant.compare_at_price));
			if (Settings.getSettingValue('search.removePriceDecimal')) {
				price = Utils.removeDecimal(price);
				compareAtPrice = Utils.removeDecimal(compareAtPrice);
			}
		}
		
		// Build Price
		var result = '';
		if (Settings.getSettingValue('search.showSuggestionProductPrice')) {
			if (onSale && Settings.getSettingValue('search.showSuggestionProductSalePrice')) {
				result = this.getTemplate(InstantSearchResultItemProduct.tempType.PRICE_SALE);
			} else {
				result = this.getTemplate(InstantSearchResultItemProduct.tempType.PRICE);
			}
		}
		return result
			.replace(/{{regularPrice}}/g, price)
			.replace(/{{compareAtPrice}}/g, compareAtPrice);
    }
    
    InstantSearchResultItemProduct.prototype.beforeRender = function (){
      if (this.data) {
		var selectedVariant = '';
        for (var i = 0; i < this.data.variants.length; i ++) {
            if (this.data.variants[i].available == true) {
                selectedVariant = this.data.variants[i];
                break;
            }
        }
        if (selectedVariant == '') {
          return;
        }
      	
      	this.imageUrl = this.data.images_info.length > 0 ? Utils.optimizeImage(selectedVariant.image, '200x') : boostPFSConfig.general.no_image_url;
      }	
    }
  */
    // End   // Ticket # 133205
   
  
})();